import { orderBy } from 'lodash';
import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import {
    autoinject,
    bind,
    deepStringFind,
    inject,
    NothingHere,
    PowerBIStore,
    SubTopBar,
    Title,
    toArray,
} from 'Mri.Web.Common';
import * as React from 'react';
import { BsBriefcase } from '@react-icons/all-files/bs/BsBriefcase';
import { RouteComponentProps } from 'react-router';
import { LinkContainer } from 'react-router-bootstrap';
import { Input } from 'reactstrap';
import { AppStore } from '../Core/AppStore';

export interface IDashboardsViewProps extends RouteComponentProps<undefined> {}

@autoinject
@observer
export class DashboardsView extends React.Component<IDashboardsViewProps> {
    @action
    public async componentDidMount() {
        this.loading = true;

        try {
            await this.powerBIStore.loadPowerBiDashboardsAsync();
        } catch (e: any) {
            this.appStore.notificationHandle.setError(e);
        } finally {
            this.loading = false;
        }
    }

    public render() {
        return (
            <div className="container-fluid py-3">
                <Title>Power BI Dashboards</Title>
                <SubTopBar>
                    <Input
                        type="text"
                        placeholder="Search for dashboard"
                        value={this.searchValue}
                        onChange={this.onSearchInputChange}
                        className="mw-450"
                    />
                </SubTopBar>

                <div className="row">
                    <div className="col-12">
                        {this.dashboards.map((d: any) => (
                            <LinkContainer to={`/bi/dashboards/${d.id}`} key={d.id}>
                                <a className="btn-link">
                                    <div className="card mb-3">
                                        <div className="card-body p-0">
                                            <div className="input-group-prepend">
                                                <span className="bg-gray p-2 rounded-start" id="basic-addon1">
                                                    <BsBriefcase />
                                                </span>

                                                <div className="p-2 d-inline-block">{d.displayName}</div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </LinkContainer>
                        ))}

                        <NothingHere
                            empty={this.powerBIStore.dashboards.size <= 0}
                            loading={this.loading}
                            icon={<BsBriefcase />}
                            label="No Dashboards Published"
                            loadingMessage="Loading Dashboards..."
                        />
                    </div>
                </div>
            </div>
        );
    }

    @computed
    private get dashboards() {
        let dashboards = toArray(this.powerBIStore.dashboards);

        if (this.searchValue) dashboards = dashboards!.filter(o => deepStringFind(o, this.searchValue));

        return orderBy(dashboards, d => d.displayName);
    }

    @bind
    @action
    private onSearchInputChange(event: React.FormEvent<HTMLInputElement>) {
        const target = event.target as HTMLInputElement;
        this.searchValue = target.value;
    }

    @observable
    private searchValue: string = '';
    @inject
    private powerBIStore!: PowerBIStore;
    @inject
    private appStore!: AppStore;
    @observable
    private loading = false;
}
